<template>
  <div class="robo-wrapper">
    <div style="width: 100%; text-align: left; padding: 8px;">
      <a @click="changeView(false, false, null)"><span class="mdi mdi-chevron-left -right-4px"></span>戻る</a>
    </div>
    <h2 :style="makeColor()">ロボ一覧</h2>
    <template v-for="(bot, idx) in widgetData.bots">
      <div class="workday-tooltip">
        <div class="tooltip-workday-message" v-if="isOffDuty(bot, widgetData.todayIsHoliday)">{{getWorkDayMessage(bot)}}<br>{{getWorkTimeMessage(bot)}}</div>
        <div
          :key="idx"
          class="-robo-card"
          @click="openChatBot(bot, idx)">
          <span class="tag tag-num" v-if="isStartBot(bot) & selectTagNewMsg>0">{{selectTagNewMsg}}</span>
          <div class="-robo-left">
            <img @error="imageError(bot)" :src="getIcon(bot)" v-if="loadImageError(bot)"/>
            <img src="@/assets/template/robot.png" v-else />
          </div>
          <div class="-robo-right">
            <p>{{bot.display_name}}</p>
            <p style="font-size: 12px; color: rgba(0, 0, 0, 0.2);">会話を開始する</p>
          </div>
          <a :style="makeColor()" style="position: absolute; right: 8px; top: 22px; font-size: 24px;">
            <span class="mdi mdi-chevron-right"></span>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  isOffDuty,
  getWorkDayMessage,
  getWorkTimeMessage,
} from '@/functions/robo/roboOffDuty'
export default {
  props: {
    color: {
      type: Object,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    selectTagNewMsg: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isImageError: []
    }
  },
  methods: {
    changeView (isDetail, isStoryView, viewType) {
      this.$emit('changeView', {
        isDetail: isDetail,
        isStoryView: isStoryView,
        viewType: viewType
      })
    },
    getIcon (bot) {
      if (bot.icon_data) {
        return bot.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    makeColor () {
      return {
        'color': this.color.iconBg + '!important'
      }
    },
    openChatBot (b, idx, todayIsHoliday) {
      if (isOffDuty(b, todayIsHoliday)) {
        // 勤務時間外
        return
      }
      this.$emit('openChatBot', {
        bot: b,
        idx: idx
      })
    },
    isOffDuty (robo, todayIsHoliday) {
      // ロボ非番判定
      return isOffDuty(robo, todayIsHoliday)
    },
    getWorkDayMessage (robo) {
      // 稼働日メッセージ取得
      return getWorkDayMessage(robo)
    },
    getWorkTimeMessage (robo) {
      // 稼働時間メッセージ取得
      return getWorkTimeMessage(robo)
    },
    imageError (bot) {
      this.isImageError.push(bot.bot_id)
    },
    loadImageError(bot) {
      if　(this.isImageError.indexOf(bot.bot_id) == -1){
        return true
      } else {
        return false
      }
    },
    isStartBot (b) {
      console.debug('*** Start *** isStartBot')
      console.debug('b: ' + JSON.stringify(b))
      var urlAryS = b.start_url.split('|')
      for (var j in urlAryS) {
        if (urlAryS[j] == this.data.url) return true
      }
      return false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// ロボ関連
.robo-wrapper {
  border-radius: 8px;
  width: calc(100% - 24px);
  height: auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  margin: 8px;
  padding: 8px 0px;
  h2 {
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
  }
  .-robo-card {
    position: relative;
    border-radius: 8px;
    height: auto;
    width: calc(100% - 24px);
    margin: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    cursor: pointer;
    transition: 0.5s;
    .-robo-left {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 80px;
        width:  80px;
        padding: 12px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .-robo-right {
      width: calc(100% - 120px);
      padding: 8px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: -16px;
      p {
        padding-left: 8px;
        text-align: left;
        font-size: 16px;
        font-weight: 600;
      }
      button {
        padding: 8px 16px;
        border-radius: 16px;
      }
    }
  }
  .-robo-card:hover {
    transform: scale(1.025);
  }
  .-footer {
    border-top: solid thin #ccc;
    padding: 8px;
  }
  .tag-num {
    display: none;
    position: absolute;
    font-size: 16.5px;
    right: -5px;
    top: -5px;
    background: #ff3355;
    color: white;
    width:  32px;
    height: 32px;
    border-radius: 50%;
    z-index: 100;
    animation: huwahuwa 2.35s ease infinite;
  }
}
.workday-tooltip{
  position : relative;
  cursor   : pointer;
}
.tooltip-workday-message {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  // width         : 200px;
  z-index       : 10;
  text-align: center;
}
.tooltip-workday-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.workday-tooltip:hover .tooltip-workday-message{
  display : inline-block;
  top     : 34px;
  left    : -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/RoboContentList.vue